import { FormControlLabel, Switch as MUISwitch, SwitchProps } from '@material-ui/core'
import React, { FC, MutableRefObject, ReactElement, useRef } from 'react'
import uuid from 'uuid-random'
import { IsStringEmpty, isStringNotEmpty } from '../../../../NonReact/utils/GlobalFunctions'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'
import Label from '../Label'

type Props = {
    labelOn?: string
    labelOff?: string
    handleChange?: (newValue: boolean) => void
    singleTitle?: string
} & SwitchProps

export const Switch: FC<Props> = ({
    labelOn,
    labelOff,
    checked,
    handleChange,
    className,
    singleTitle,
    ...props
}: Props): ReactElement => {
    const id: MutableRefObject<string> = useRef(uuid())

    const onChange = (): void => {
        if (handleChange) {
            handleChange(!checked)
        }
    }

    return (
        <div className={`akixi-switch ${className ?? ''}`}>
            <Label htmlFor={id.current} customClass='as-label-label'>
                <p className='as-label'>{isStringNotEmpty(singleTitle) ? singleTitle : labelOff}</p>
            </Label>
            <FormControlLabel
                className='switch-container'
                control={<MUISwitch checked={checked} onChange={onChange} {...props} disableRipple={true} />}
                label=''
                id={id.current}
            />
            {IsStringEmpty(singleTitle ?? EMPTY_STRING) ? <p className='as-label'>{labelOn}</p> : <></>}
        </div>
    )
}
